import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

const httpOptions= new HttpHeaders()
  .set('content-type', 'application/json');

@Injectable({
  providedIn: 'root'
})
export class ResignationService {

  constructor(private http: HttpClient) { }

  applyResign(model: any){
    const token = localStorage.getItem('token');
    const url = `${environment.apiBaseUrl}/add-resign`;
    return  this.http.post<any>(url, model, {headers: httpOptions.append('Authorization', `Bearer ${token}`)});
  }

  getResignationList(){
    const token = localStorage.getItem('token');
    const url = `${environment.apiBaseUrl}/get-resigns-admin`;
    return  this.http.post<any>(url, null, {headers: httpOptions.append('Authorization', `Bearer ${token}`)});
  }

  updateResignStatus(model: any){
    const token = localStorage.getItem('token');
    const url = `${environment.apiBaseUrl}/update-resign-status-admin`;
    return  this.http.post<any>(url, model, {headers: httpOptions.append('Authorization', `Bearer ${token}`)});
  }

  addTermination(model: any){
    const token = localStorage.getItem('token');
    const url = `${environment.apiBaseUrl}/add-termination-admin`;
    return this.http.post<any>(url, model, {headers: httpOptions.append('Authorization', `Bearer ${token}`)});
  }

}
